import { create } from 'zustand';

interface AccountNumber {
  value: string;
  error: boolean;
  show: boolean;
}

interface CoreState {
  accountNumber: AccountNumber;
  setAccountNumber: (updates: Partial<AccountNumber>) => void;
}

export const useCoreStore = create<CoreState>((set) => ({
  accountNumber: { value: '', error: false, show: false },
  setAccountNumber: (updates: Partial<AccountNumber>) =>
    set((state) => ({
      accountNumber: { ...state.accountNumber, ...updates },
    })),
}));
